import { Injectable } from "@angular/core";
import { CryptoService } from "../../security/crypto.service";
import { StorageServiceInterface } from "../storage.service.interface";
import { isNotNull } from "@/core/utils/functions";

/**
 * @author Lucas P. Soares
 * @contact lucas.lps@ecxus.com.br
 * @date 10/08/2022
 * @version 1.0.0
 * @description <p> Classe Service para gerenciar os armazenamento no localStorage </p>
 *
 * @revisions_history
 * - Version   -   Author    -    Description
 *  1.0.0       Lucas Peres   Criação da classe
 */
@Injectable({
    providedIn: "root",
})
export class LocalStorageServiceImpl implements StorageServiceInterface {

    constructor(private cryptoService: CryptoService) {}

    setItem(key: string, value: any): void {
        if (isNotNull(value)) {
            const valueCrypto = this.cryptoService.encryptAES(
                JSON.stringify(value)
            );
            window.localStorage.setItem(key, valueCrypto);
        }
    }

    getItem(key: string): any {
        let obj = window.localStorage.getItem(key);
        if (isNotNull(obj)) {
            const valueDecrypto = this.cryptoService.decryptAES(obj as string);
            return obj ? JSON.parse(valueDecrypto) : obj;
        }
        return undefined;
    }

    removeItem(key: string): void {
        window.localStorage.removeItem(key);
    }

    clearAll(): void {
        window.localStorage.clear();
    }
}
